// Created by carsonaberle at 11/24/21
export const numberInCart = '# in cart';
export const numberRemoved = '# removed';
export const numberOfExtras = '# of extras';
